import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@asigna/kit';
import { getPendingMultisigs, removeInviteMultisigRequest } from 'api';
import { NotificationCard } from 'components/NotificationCard';
import useNetwork from 'hooks/use-network';
import closeIcon from 'images/close.svg';
import { toast } from 'sonner';
import { StxChain, usePendingSafes } from 'store';
import { StxChainEnum } from 'types/enums';

import trashIcon from './utils/images/trash.svg';

interface TransactionCommonProps {
  id: string;
  onClose: () => void;
}

export const DeletePendingDialog: React.FC<TransactionCommonProps> = ({ id, onClose }) => {
  const history = useHistory();
  const [network] = useNetwork();

  const { setPendingSafes } = usePendingSafes();

  const handleDelete = async () => {
    await removeInviteMultisigRequest(id).then(async () => {
      const pendingMulitisgs = await getPendingMultisigs(StxChainEnum[network] as any as StxChain);
      setPendingSafes(pendingMulitisgs);
      onClose();
      if (history.location.pathname !== '/') {
        history.push('/');
      }
      toast(
        () => (
          <NotificationCard
            title="Vault Removed"
            message="Vault removed successfully."
            type="success"
          />
        ),
        {
          className: 'w-full',
        }
      );
    });
  };

  return (
    <div className="flex flex-col gap-32">
      <div className="flex items-center justify-between">
        <p className="text-r20">Delete</p>
        {/* TODO Icon Button */}
        <Button
          leftIcon={closeIcon}
          onClick={onClose}
          colorType="secondary"
          size="sm"
          className="w-36 !px-0"
        />
      </div>

      <div className="flex flex-col items-center gap-16">
        <div className="flex w-56 h-56 items-center justify-center border border-white-10 rounded-[56px] mb-8">
          <img src={trashIcon} width={24} height={24} alt="delete icon" />
        </div>
        <p className="text-r20 text-white">Delete this pending vault?</p>
        <span className="text-m14 text-regular text-center">
          This action will remove it from all current owners.
        </span>
      </div>
      <div className="flex items-center gap-16 w-full">
        <Button message="Cancel" onClick={onClose} colorType="secondary" fullWidth />
        <Button message="Yes, delete" onClick={handleDelete} colorType="primary" fullWidth />
      </div>
    </div>
  );
};
